const { log } = console

module.exports = function store (state, emitter) {
  emitter.on('play-key-up', event => {
    log('play-key-up', event)
    if (state.isGamePlaying) {
      state.vm.postIOData('keyboard', {key: event.key, isDown: false})
    }
  })

  emitter.on('play-key-down', event => {
    log('play-key-down', event)
    if (state.isGamePlaying) {
      state.vm.postIOData('keyboard', {key: event.key, isDown: true})
    }
  })
}
